import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Body from '../Components/layout/Body';
import { TestDriveInfoTable } from '../Components/layout/DisplayTestDriveInfo';
import { TABS } from './ConstPaths';
import TestDriveDevSidebar from './TestDriveDevSidebar';

const TD_REVIEW_HELP = `
  <div>
    <p>
    This page just lets you see the Test-drives you've completed so far, as a reminder of what you've done.   
    The next section, Review, is all about deciding what to do next, based on the information you've gathered so far.
    You're getting there!
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  completedTestDrives: PropTypes.arrayOf(PropTypes.object),
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  completedTestDrives: []
};

//content sub-component with unique content for this page
function TestDriveReviewContent(props) {
  const activeTestDriveId = props.activeTestDriveId;
  const completedTestDrives = props.completedTestDrives;
  const td_path = TABS.TEST;
      
  //just in case we get to this view without any test-drives:
  //TODO what to do about viewing test-drives from previous sessions
  if(completedTestDrives.length === 0){
    return(
      <>
      <p><strong>Note:</strong> There are no test-drives shown here because you haven't completed any test-drives yet.</p>
      <p>You can:</p>
      <ul>
        <li><Link to={td_path}>Start a Test-drive</Link>, complete one or more, then review the results here.</li>
      </ul>
      </>
    );
  }
  else{
    let moreThanOne = (completedTestDrives.length > 1);
    return(
      <>
      <p><strong>Good work!</strong> You completed {completedTestDrives.length} {moreThanOne ? 'Test-drives' : 'Test-drive'} so far. We've added these to Your Prospects.</p>
      <p>Take a moment to review the Test-drives below.</p>
      <TestDriveInfoTable
        activeTestDriveId={activeTestDriveId}
        testDrives={completedTestDrives}
        showDetailsCol={true}
      />
      </>
    );
  }
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function TestDriveReview(props) {
  const firstName = props.firstName;
  const activeTestDriveId = props.activeTestDriveId;
  const completedTestDrives = props.completedTestDrives;
  const dev = props.dev || {};

  const pageData = {
    image: "",
    faIcon: "",
    pageSymbolClassName: "aa-section-symbol test-drive",
    title: `Review all Test-drives`,
    subTitle: ``,
    learnMore: {linkText: "Learn More about reviewing Test-drives",
                title: "Reviewing Test-drives",
                content: TD_REVIEW_HELP
              },
    nextRoute: TABS.REVIEW, //TODO used for now instead of an onContinue callback 
    sidebar: false
  }

  console.log("Rendering TestDriveReview");
  
  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <TestDriveReviewContent 
          activeTestDriveId={activeTestDriveId}
          completedTestDrives={completedTestDrives}
        />
      } 
      sidebarComponent={
        dev.showDevSidebar 
        &&
        <TestDriveDevSidebar 
          activeTestDriveId={dev.tdId}
          activeTestDrive={dev.td}
          activeTestDriveActivityId={dev.actId}
          activeTestDriveActivities={dev.acts}
          completedTestDrives={dev.ctds}
        />  
      }
    />
    </>
  );
}

TestDriveReview.propTypes = propTypes;
TestDriveReview.defaultProps = defaultProps;

export default TestDriveReview;